import { render, staticRenderFns } from "./wisdomClassStatic.vue?vue&type=template&id=2f15f4e8&scoped=true"
import script from "./wisdomClassStatic.vue?vue&type=script&lang=js"
export * from "./wisdomClassStatic.vue?vue&type=script&lang=js"
import style0 from "./wisdomClassStatic.vue?vue&type=style&index=0&id=2f15f4e8&prod&lang=scss&scoped=true"
import style1 from "./wisdomClassStatic.vue?vue&type=style&index=1&id=2f15f4e8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f15f4e8",
  null
  
)

export default component.exports